import { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';
import { messaging } from '../firebase/firebase';

export const useFirebaseMessaging = ({ onMessageReceived }) => {
  useEffect(() => {
    if (!messaging) {
      console.warn('Firebase messaging not available');
      return;
    }

    // Обробка повідомлень коли додаток активний (foreground)
    const unsubscribe = onMessage(messaging, (payload) => {
      console.log('Received foreground message:', payload);

      const { notification, data } = payload;

      // Викликаємо callback для оновлення локального стану
      if (onMessageReceived) {
        onMessageReceived({
          title: notification?.title,
          body: notification?.body,
          chatId: data?.chatId,
          data: data || {}
        });
      }

      // Показуємо нотифікацію тільки якщо браузер не в фокусі
      if (document.hidden && notification && Notification?.permission === 'granted') {
        const n = new Notification(notification.title || 'Нове повідомлення', {
          body: notification.body,
          icon: '/logo192.png',
          data: data || {}
        });
        n.onclick = () => {
          try {
            window.focus();
            if (data?.chatId) {
              window.postMessage({ type: 'OPEN_CHAT', chatId: data.chatId }, '*');
            }
            n.close();
          } catch (e) {}
        };
      }
    });

    return unsubscribe;
  }, [onMessageReceived]);
};
